import { render, staticRenderFns } from "./ProfileCandidate.vue?vue&type=template&id=25d8e1b6"
import script from "./ProfileCandidate.vue?vue&type=script&lang=js"
export * from "./ProfileCandidate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports